import { render, staticRenderFns } from "./wjtpay.vue?vue&type=template&id=f26d0bc2&scoped=true"
import script from "./wjtpay.vue?vue&type=script&lang=js"
export * from "./wjtpay.vue?vue&type=script&lang=js"
import style0 from "./wjtpay.vue?vue&type=style&index=0&id=f26d0bc2&prod&scoped=true&lang=css"
import style1 from "./wjtpay.vue?vue&type=style&index=1&id=f26d0bc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f26d0bc2",
  null
  
)

export default component.exports